import Actions from '../../odata/actions';

const actions = new Actions('automatedResponse', 'automatedResponses');

export default actions;
